export const projectsData = [
  {
    id: 1,
    title: "GymKhana Bar | Lougne ",
    categories: "Commercial",
    description:
      "An atmospheric lounge space where sophistication meets leisure, blending warm textures with dramatic lighting to create an immersive social experience that elevates the art of relaxation.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/BAR/BAR01+ps01.webp",

    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/BAR/BAR01+ps01.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/BAR/BAR02+ps02.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/BAR/BAR03.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/BAR/revised.webp",
    ],
    details:
      "Detailed description and specifications of the BAR commercial project.",
  },
  {
    id: 2,
    title: "Gym Interior",
    categories: "Commercial",
    description:
      "A dynamic fitness environment where form follows function, featuring thoughtfully zoned training areas that balance energetic spaces with moments of respite, all unified by a contemporary design language.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/GYM01+ps.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/GYM01+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/GYM02+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/GYM+CARDIO+CH.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/REC+03+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/rec+01+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/GYM/rec+021.webp",
    ],
    details: "Detailed description and specifications of the Gym project.",
  },
  {
    id: 3,
    title: "Geeta Mandir",
    categories: "Commercial",
    description:
      "A sacred architectural expression that harmonizes traditional temple elements with contemporary sensibilities, creating a serene sanctuary where light, material, and proportion converge to evoke spiritual tranquility.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Geeta+Mandir/render+gray+ps.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Geeta+Mandir/render+gray+02+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Geeta+Mandir/render+gray+ps.webp",
    ],
    details:
      "Detailed description and specifications of the residential project.",
  },
  {
    id: 4,
    title: "Food Bazaar Kitty Hall",
    categories: "Commercial",
    description:
      "An elegant gathering space designed for social communion, featuring versatile spatial arrangements and ambient lighting that transforms the environment from vibrant daytime meetings to intimate evening gatherings.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Kitty+Hall/kitty+view.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Kitty+Hall/kitty+view.webp",
    ],
    details:
      "Detailed description and specifications of the Kitty Hall project.",
  },
  {
    id: 5,
    title: "Mandir Interior",
    categories: "Commercial",
    description:
      "A devotional interior that balances ornate traditional detailing with clean architectural lines, creating a contemplative atmosphere where materiality and light work in harmony to enhance the spiritual experience.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Mandir/mandir01+ed.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Mandir/mandir01+ed.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Mandir/mandir03.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Mandir/mandir04.webp",
    ],
    details: "Detailed description and specifications of the Mandir project.",
  },
  {
    id: 6,
    title: "VS Tower",
    categories: "Commercial",
    description:
      "A striking commercial edifice with a rhythmic façade that plays with light and shadow, creating a distinctive urban presence while optimizing interior functionality for diverse business requirements.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Commercial+elev/comercal+evlevation.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Commercial+elev/comercal+evlevation.webp",
    ],
    details:
      "Detailed description and specifications of the Commercial Elevation project.",
  },
  {
    id: 29,
    title: "Victoria Garden",
    categories: ["Urban Design", "Interiors"],
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/master+plan/final+view+3.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/FINAL+VIEW+5+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/FRONT+BEDROOM_1+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/final+kitchen++1+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/final+view+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/final+view+1+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/final+view+4+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/final+view+6+-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/final+view+back+bedroom++-+Copy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/master+plan/1.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/master+plan/MASTERPLAN.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/master+plan/final+view+2+COLONY.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Victoria+Garden/master+plan/final+view+3.webp",
    ],
    description:
      "A harmonious master-planned community that weaves landscape and architecture into a cohesive living environment, featuring thoughtfully articulated residential spaces within a framework of communal gardens and pedestrian pathways.",
    details:
      "Includes various perspectives and the master plan of the Victoria Garden urban design project.",
  },

  {
    id: 12,
    title: "SSGI Office Interiors",
    categories: "Interiors",
    description:
      "A progressive workplace design that balances professional efficiency with aesthetic refinement, featuring a fluid spatial arrangement that fosters collaboration while providing moments of privacy through sophisticated material transitions.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/108.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/108.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/301.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/302.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/305.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/306.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/307.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/308.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/403.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/404.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/407.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/408.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Office+interiors/psd+light+enhance.webp",
    ],
    details:
      "Detailed description and specifications of the Office Interiors project.",
  },
  {
    id: 13,
    title: "Bali Travels House",
    categories: ["Residential", "Interiors"],
    description:
      "A bespoke residence crafted for Bali Travels, where architectural volumes create a dialogue between interior and exterior spaces, featuring curated material palettes and thoughtful spatial sequences that reflect the client's distinctive character.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/01.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/01.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/022.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/FF_MASTER+BEDROOM.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/FINAL+VIEW+2.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/FINAL+VIEW+dwg+room+25-6-2022.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/FINAL+VIEW.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/Master+Bedroom_1.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/back+yard+view+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/final+15.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/grayyyy.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/reeeee.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/render01+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/terrace.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Bali+Travels/view+.webp",
    ],
    details:
      "Detailed description and specifications of the Bali Travels House residential project.",
  },
  {
    id: 18,
    title: "Rajesh's Residence",
    categories: ["Residential", "Interiors"],
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/1.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/1.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/fianl+view+24.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/final+view+25.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/final+view+5.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/final+view+DWG+ROOM.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Gurdaspur/final+view+LOBBY.webp",
    ],
    description:
      "A residential composition of interlocking volumes that embraces natural light, featuring double-height spaces and carefully considered sight lines that create visual connections between private and communal areas of the home.",
    details: "Details about the project can be added here.",
  },
  {
    id: 30,
    title: "Eldeco",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Eldeco/111.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Eldeco/111.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Eldeco/222.webp",
    ],
    description:
      "An architectural statement balancing bold geometric forms with delicate material textures, creating living spaces that transition gracefully between intimate enclosures and expansive vistas of the surrounding landscape.",
    details: "Details about the project can be added here.",
  },

  {
    id: 15,
    title: "Sharma Residence",
    categories: ["Residential", "Interiors"],
    description:
      "A refined residential experience where spatial fluidity meets textural richness, featuring considered proportions and subtle transitions between living environments that respond intuitively to the rhythms of daily life.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/GTB/01.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/GTB/01.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/GTB/final+view++bedroom.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/GTB/final+view+bedroom++28-3-2022+MASTER.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/GTB/final+view+bedroom++28-3-2022.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/GTB/view+right+bedroom+27-3-2022.webp",
    ],
    details:
      "Detailed description and specifications of the GTB House residential project.",
  },
  {
    id: 16,
    title: "IAS/PCS Society, New Chandigarh",
    categories: "Residential",
    description:
      "A distinguished residential enclave that balances prestige with comfort, featuring timeless architectural elements and sophisticated interior details that create a sense of permanence and refined living.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/FINAL+VIEW+26.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/FINAL+VIEW+26.webp",
    ],
    details:
      "Detailed description and specifications of the Random House 4 residential project.",
  },
  {
    id: 17,
    title: "Mexmon Residence",
    categories: "Residential",
    description:
      "A residential dialogue between solid and void, where crisp linear forms create a contemporary living environment that celebrates the interplay of light across thoughtfully articulated facades and interior spaces.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Exterior.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Exterior.webp",
    ],
    details:
      "Detailed description and specifications of the Random House 3 residential project.",
  },
  {
    id: 19,
    title: "Garden Villa",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/H02.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/H02.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/Rajesh+Eldeco/222.webp",
    ],
    description:
      "A holistic living environment where architecture and landscape merge seamlessly, featuring terraced gardens and sheltered outdoor rooms that extend the interior experience into nature while maintaining privacy and comfort.",
    details: "Details about the project can be added here.",
  },
  {
    id: 20,
    title: "Surinder's Residence",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/exxx.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/exxx.webp",
    ],
    description:
      "A personalized architectural response to site and client, featuring sculptural forms that create a dynamic play of light throughout the day while organizing interior spaces around central gathering areas that foster connection.",
    details: "Details about the project can be added here.",
  },
  {
    id: 21,
    title: "Manpreet's Residence",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/UE-II/1.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/UE-II/1.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/UE-II/2.webp",
    ],
    description:
      "A contemporary residential composition where horizontal planes create a sense of graceful suspension, featuring material transitions that guide movement through living spaces designed to frame views and capture natural light.",
    details: "Details about the project can be added here.",
  },
  {
    id: 22,
    title: "Singla, New Chandigarh",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/final+view+7.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/final+view+7.webp",
    ],
    description:
      "An elegant residential expression that responds to climate and context through thoughtful orientation and material selection, creating living spaces that balance openness with intimacy through architectural layering.",
    details: "Details about the project can be added here.",
  },
  {
    id: 23,
    title: "Chauhan's Residence",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/kunal+residence.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/kunal+residence.webp",
    ],
    description:
      "A residential sanctuary designed around principles of spatial generosity, featuring double-height volumes that create breathing space within the home while maintaining intimate proportions in personal retreats.",
    details: "Details about the project can be added here.",
  },
  {
    id: 14,
    title: "Aggarwal Residence",
    categories: "Residential",
    description:
      "A tailored living environment that reflects the client's personality through architectural gestures, featuring clean lines and warm material palettes that create a sense of welcome while maintaining sophisticated aesthetics.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/2.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/2.webp",
    ],
    details:
      "Detailed description and specifications of the Random House 2 residential project.",
  },
  {
    id: 24,
    title: "Saraf's Residence",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/malout/1111.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/malout/1111.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/malout/2.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/malout/3.webp",
    ],
    description:
      "A residential composition that harmonizes traditional influences with contemporary simplicity, featuring tactile material selections and thoughtful spatial sequences that guide residents from public to increasingly private domains.",
    details: "Details about the project can be added here.",
  },
  {
    id: 25,
    title: "Doctor's Residence",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/view+15-3-2023.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/view+15-3-2023.webp",
    ],
    description:
      "A tranquil residential design that balances professional needs with personal retreat, featuring a clear architectural language that creates distinct zones while maintaining visual continuity throughout the living spaces.",
    details: "Details about the project can be added here.",
  },
  {
    id: 26,
    title: "Singh's Residence",
    categories: "Residential",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/view+18-01-2023.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/residential/view+18-01-2023.webp",
    ],
    description:
      "A modern interpretation of residential comfort that employs subtle material shifts and carefully positioned apertures to create living spaces that respond to daily rhythms and seasonal changes with equal grace.",
    details: "Details about the project can be added here.",
  },
  {
    id: 27,
    title: "Ameek's Paradise",
    categories: "Urban Design",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek's+Paradise/to+be+revised/mac+d+01.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek%27s+Paradise/to+be+revised/2024-04-25_Masterplan-Recovered_merged.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek%27s+Paradise/to+be+revised/a1+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek%27s+Paradise/to+be+revised/a2++ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek%27s+Paradise/to+be+revised/jalander+comercal+ex01+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek%27s+Paradise/to+be+revised/jalander+comercal+ex02+ps.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek's+Paradise/to+be+revised/mac+d+01.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Urban+Design-Masterplanning/Ameek%27s+Paradise/to+be+revised/mac+d+02.webp",
    ],
    description:
      "A visionary urban ensemble that orchestrates built form, landscape, and infrastructure into a cohesive neighborhood experience, creating a sense of place through thoughtful transitions between public and private realms.",
    details: "Details about the project can be added here.",
  },

  {
    id: 8,
    title: "Roof Top Bar",
    categories: "Commercial",
    description:
      "An elevated social experience where architecture frames the sky, featuring strategic sight lines and layered spatial arrangements that create intimate gathering zones within an expansive rooftop environment.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+1.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+1.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+2.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+3.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+6.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+7.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+8.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Roof+TOP+bar/4_Photo+-+9.webp",
    ],
    details:
      "Detailed description and specifications of the Roof Top Bar project.",
  },
  {
    id: 9,
    title: "Kids Zone",
    categories: "Commercial",
    description:
      "A playful architectural environment designed at a child's scale, featuring organic forms and interactive spaces that stimulate imagination while ensuring safety through thoughtful material selection and spatial planning.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/kIDS'S+ZONE/k01.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/kIDS'S+ZONE/k01.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/kIDS'S+ZONE/k2.webp",
    ],
    details:
      "Detailed description and specifications of the Kids Zone project.",
  },
  {
    id: 7,
    title: "Mexmon",
    categories: "Commercial",
    description:
      "A commercial destination with a distinctive architectural identity, featuring a rhythmic façade treatment that creates visual interest while organizing interior spaces that flow intuitively for visitors and occupants alike.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Mexmon/mall+view+ps.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/Mexmon/mall+view+ps.webp",
    ],
    details: "Detailed description and specifications of the Maxmon project.",
  },
  {
    id: 10,
    title: "Guru Nanak Ply-Wood",
    categories: "Commercial",
    description:
      "A commercial showcase that celebrates the material it represents, featuring warm wood elements and thoughtful display areas that transform a utilitarian space into an engaging customer experience through architectural detailing.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/render01+(ps).webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/render01+(ps).webp",
    ],
    details:
      "Detailed description and specifications of the Ply Wood Shop project.",
  },
  {
    id: 11,
    title: "Sai Hospital",
    categories: "Commercial",
    description:
      "A healing environment where technical requirements harmonize with human comfort, featuring intuitive wayfinding and layered spaces that balance clinical efficiency with the emotional needs of patients and healthcare professionals.",
    mainImage:
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/sai+hospital/Exterior_we+transfer.webp",
    images: [
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/sai+hospital/Exterior_we+transfer.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/sai+hospital/h01.webp",
      "https://vsa-architect.s3.ap-south-1.amazonaws.com/Website+3D/Commercial/sai+hospital/h02.webp",
    ],
    details:
      "Detailed description and specifications of the Sai Hospital project.",
  },
];
